import Card from "react-bootstrap/Card";
import { OutboundLink } from "react-ga";
import React from "react";
import Skeleton from "react-loading-skeleton";
import artifact from "../assets/artifact.svg";
import classNames from "classnames";
import creature from "../assets/creature.svg";
import enchantment from "../assets/enchantment.svg";
import instant from "../assets/instant.svg";
import planeswalker from "../assets/planeswalker.svg";
import salt_48 from "../assets/salt_48.png";
import sorcery from "../assets/sorcery.svg";
import styles from "../styles/DeckSummaryPanel.module.scss";
import useDarkMode from "use-dark-mode";
import { useSelector } from "react-redux";

const DeckSummaryPanel = () => {
  const { isLoading, data } = useSelector((state) => state.pagedata);
  const deck = data.panels.deckinfo?.deck_preview;
  const darkMode = useDarkMode(false);

  return (
    <>
      <h5 className="title">Deck Summary</h5>
      <Card className="shadow-sm">
        <Card.Body className={classNames(styles.body, { [styles.dark]: darkMode })}>
          <>
            <div className={styles.types}>
              {[
                { alt: "Creatures", key: "creature", src: creature },
                { alt: "Instants", key: "instant", src: instant },
                { alt: "Sorceries", key: "sorcery", src: sorcery },
                { alt: "Artifacts", key: "artifact", src: artifact },
                { alt: "Enchantments", key: "enchantment", src: enchantment },
                { alt: "Planeswalkers", key: "planeswalker", src: planeswalker },
              ].map(({ alt, key, src }) => (
                <span key={key}>
                  <img alt={alt} className={styles.type} src={src} />
                  {deck && `  ${deck[key]}`}
                </span>
              ))}
            </div>
            <div>{deck?.second_row || <Skeleton />}</div>
            <div>
              {deck?.salt ? (
                <>
                  <img alt="Salt" className={styles.type} src={salt_48} /> ${deck.salt.toFixed(2)}
                </>
              ) : (
                <Skeleton />
              )}
            </div>
            <div>{deck?.savedate ? `Updated: ${deck?.savedate}` : <Skeleton />}</div>
            {!deck ||
              (deck.show_url && (
                <div>
                  {!deck ? (
                    <Skeleton />
                  ) : (
                    <>
                      {"Source: "}
                      <OutboundLink
                        alt="Deck Source"
                        eventLabel={deck.url}
                        target="_blank"
                        to={deck.url}
                      >
                        {deck.url.split("/")[2]}
                      </OutboundLink>
                    </>
                  )}
                </div>
              ))}
          </>
        </Card.Body>
      </Card>
    </>
  );
};

export default DeckSummaryPanel;
